import React, { useEffect, useState } from "react";
import {
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { getInventorySuppliers } from "../../../api/inventoryService";

const SupplierAutocomplete = ({
  supplierId = "",
  value,
  onChange,
  label = "Select Supplier",
  ...props
}) => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getInventorySuppliers();
        setSuppliers(response?.data || []);
      } catch (error) {
        console.error("Error fetching suppliers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [supplierId]);

  return (
    <Autocomplete
      {...props}
      options={suppliers}
      getOptionLabel={(option) => option.name || ""}
      value={
        suppliers.find((supplier) => supplier.id === value) || null
      }
      onChange={(event, newValue) =>
        onChange?.(newValue ? newValue.id : "")
      }
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default SupplierAutocomplete;